import $$api from 'models/api';

import { type ControlsData } from 'types/zod/controls-data';

const ControlsDataService = {
    data: {} as ControlsData,

    get: async (types: string[]) => {
        // @ts-ignore
        const typesToFetch = types.filter((type) => !ControlsDataService.data[type]);

        if (typesToFetch.length) {
            const controlsData: ControlsData = await $$api.controlsData.getFx(typesToFetch.join(','));
            ControlsDataService.data = Object.assign(ControlsDataService.data, controlsData);
        }

        const requestedData = {} as ControlsData;
        for (const type of types) {
            // @ts-ignore
            requestedData[type] = ControlsDataService.data[type];
        }
        return Object.assign({}, requestedData);
    },
};

export default ControlsDataService;
